import ApiError, { type FieldError } from '@Infra/FetchLib/ApiError';

export type ExtractedMessages =
	| {
			message: string;
			fieldErrors: FieldError[];
			status?: number;
	  }
	| undefined;

const extractMessages = (error: unknown): ExtractedMessages => {
	if (!(error instanceof ApiError) || !error.hasErrors()) {
		return undefined;
	}

	const { errorMessage } = error;

	if (errorMessage === undefined) {
		return undefined;
	}

	return {
		message: errorMessage,
		fieldErrors: error.fieldErrors ?? [],
		status: error.status,
	};
};

export default extractMessages;
